import {createSelector} from "reselect";

export const fullTruckloadBrokersSelector = createSelector(state => state && state.fullTruckloadBroker && state.fullTruckloadBroker && state.fullTruckloadBroker.fullTruckloadBrokers, fullTruckloadBrokersSelector => fullTruckloadBrokersSelector)
